import React from 'react'
import { Row, Col, Button } from 'antd'
import { IconHelper, login } from '../../helpers'
import { translate } from 'react-i18next'


const Empty = ({ status, keycloak, language, t }) => {
    const { IconRecentEmpty, IconUpcomingEmpty, IconAlert } = IconHelper
    return (
        <>
            <Row className="empty-list">
                <Col span={24}>
                    {status === 'recent'
                        && <>
                            <IconRecentEmpty />
                            <p>{t('empty_tab_recent')}</p>
                        </>
                    }
                    {status === 'upcoming'
                        && <>
                            <IconUpcomingEmpty />
                            <p>{t('empty_tab_upcoming')}</p>
                        </>
                    }
                    {status === 'login'
                        && <>
                            <IconAlert />
                            <p>{t('login_to_upcoming')}</p>
                            <div id="empty-list-login">
                                <Button onClick={login.bind(this, keycloak, language)} type="link" danger>
                                    Login
                                </Button>
                                <span>|</span>
                                <Button onClick={login.bind(this, keycloak, language)} type="link" danger>
                                    Register
                                </Button>
                            </div>
                        </>
                    }
                </Col>
            </Row>
        </>
    )
}

export default translate()(Empty)